import { useState } from 'react';
export function useSelected(results) {
    const [state, setState] = useState([]);
    const handleSetState = (action) => {
        const { type, payload } = action;
        if (type === 'select-all') {
            setState(results);
            return;
        }
        if (type === 'reset') {
            setState([]);
            return;
        }
        if (type === 'toggle' && payload) {
            const entityArray = Array.isArray(payload) ? payload : [payload];
            const entityIds = entityArray.map((entity) => entity.entityId);
            const stateWithoutPayload = state.filter((item) => !entityIds.includes(item.entityId));
            if (stateWithoutPayload.length === state.length) {
                setState([...state, ...entityArray]);
            }
            else {
                setState(stateWithoutPayload);
            }
        }
    };
    return [state, handleSetState];
}
